
import { createWeb3Modal, defaultWagmiConfig } from '@web3modal/wagmi/react'
import { WagmiConfig } from 'wagmi'
import { polygon } from 'viem/chains'
import { createPolygonTransport, polygonRpcUrls } from '@/lib/polygonRpc'

const projectId = import.meta.env.VITE_WALLET_CONNECT_PROJECT_ID
const appUrl = typeof window !== 'undefined' ? window.location.origin : 'https://www.maticmoon.com'

if (!projectId) {
  throw new Error('You need to provide VITE_WALLET_CONNECT_PROJECT_ID env variable')
}

const metadata = {
  name: 'Matic Moon',
  description: 'Matic Moon Web3 Platform',
  url: appUrl,
  icons: ['https://avatars.githubusercontent.com/u/37784886']
}

// Configure chains with RPC URLs
const configuredPolygon = {
  ...polygon,
  rpcUrls: {
    ...polygon.rpcUrls,
    default: {
      http: polygonRpcUrls
    },
    public: {
      http: polygonRpcUrls
    }
  }
}

// Trust registries and launch contracts are authoritative on Polygon for the MVP.
const chains = [configuredPolygon] as const

const wagmiConfig = defaultWagmiConfig({
  chains,
  projectId,
  metadata,
  enableWalletConnect: true,
  enableInjected: true,
  enableEIP6963: true,
  transports: {
    [configuredPolygon.id]: createPolygonTransport(),
  },
})

// Initialize Web3Modal with additional options
createWeb3Modal({ 
  wagmiConfig, 
  projectId, 
  defaultChain: configuredPolygon,
  chainImages: {},
  themeMode: 'dark',
  themeVariables: {
    '--w3m-z-index': 1000
  },
  tokens: {
    137: {
      address: '0x0000000000000000000000000000000000001010',
      image: 'https://assets.coingecko.com/coins/images/4713/small/matic-token-icon.png',
    },
  },
  featuredWalletIds: [
    'c57ca95b47569778a828d19178114f4db188b89b763c899ba0be274e97267d96', // MetaMask
    '19177a98252e07ddfc9af2083ba8e07ef627cb6103467ffebb3f8f4205fd7927', // Coinbase
    '38f5d18bd8522c244bdd70f3ecbcd88e3e13062dac71c1fbb1c825c1a8ded959', // Trust
    'fd20dc426fb37566d803205b19bbc1d4096b248ac04548e3cfb6b3a38bd033aa', // Enkrypt
  ]
})

export function Web3Provider({ children }: { children: React.ReactNode }) {
  return <WagmiConfig config={wagmiConfig}>{children}</WagmiConfig>
}
